<template>
  <div>
    <br />

    <a-row :gutter="25">
      <a-col :lg="8" :xs="24">
        <sdCards headless>
          <div v-if="isCard_1_Loading" >
            <a-spin />
          </div>

          <OverviewSalesCard v-else>
            <div class="icon-box box-primary">
              <SvgConverter :src="require('@/static/img/icon/NewCustomer.svg')" />
            </div>
            <div class="card-chunk">
              <CardBarChart2>
                <h2>{{ totalDeveloper }}</h2>
                <span>{{$t("pages.statistics.developer-stat.total-developer")}}</span>
              </CardBarChart2>
            </div>
          </OverviewSalesCard>
        </sdCards>
      </a-col>

      <a-col :lg="8" :xs="24">
        <sdCards headless>
          <div v-if="isCard_2_Loading">
            <a-spin />
          </div>

          <OverviewSalesCard v-else>
            <div class="icon-box box-success">
              <sdFeatherIcons type="thumbs-up" size="40"/>
              
            </div>
            <div class="card-chunk">
              <CardBarChart2>
                <h2>{{ approvedDeveloper }}</h2>
                <span>{{$t("pages.statistics.developer-stat.approved-developer")}}</span>
              </CardBarChart2>
            </div>
          </OverviewSalesCard>
        </sdCards>
      </a-col>
      <a-col :lg="8" :xs="24">
        <sdCards headless>
          <div v-if="isCard_3_Loading">
            <a-spin />
          </div>

          <OverviewSalesCard v-else>
            <div class="icon-box box-secondary">
              <sdFeatherIcons type="thumbs-down" size="40"/>
            </div>
            <div class="card-chunk">
              <CardBarChart2>
                <h2>{{ unapprovedDeveloper }}</h2>
                <span>{{$t("pages.statistics.developer-stat.unapproved-developer")}}</span>
              </CardBarChart2>
            </div>
          </OverviewSalesCard>
        </sdCards>
      </a-col>
    </a-row>
    <sdCards :title="$t('pages.statistics.developer-stat.chart-title')">
      <div v-if="isChartLoading" class="sd-spin">
        <a-spin />
      </div>

      <div v-else id="chart">
        <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
      </div>
    </sdCards>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SvgConverter from '@/components/utilities/SvgConverter.vue';
import { CardBarChart2, OverviewSalesCard } from '../../dashboard/style';

export default {
  components: {
    OverviewSalesCard,
    CardBarChart2,
    SvgConverter,
  },
  data() {
    return {
      isCard_1_Loading: true,
      isCard_2_Loading: true,
      isCard_3_Loading: true,
      isChartLoading: true,
      totalDeveloper: 0,
      approvedDeveloper: 0,
      unapprovedDeveloper: 0,
      series: [
        {
          name: this.$t('pages.statistics.developer-stat.chart-y-title'),
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: true,
        },
        theme: {
          palette: 'palette1',
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: [
            this.$t("common.january"),
            this.$t("common.febuary"),
            this.$t("common.march"),
            this.$t("common.april"),
            this.$t("common.may"),
            this.$t("common.june"),
            this.$t("common.july"),
            this.$t("common.august"),
            this.$t("common.september"),
            this.$t("common.october"),
            this.$t("common.november"),
            this.$t("common.december"),
          ],
        },
        yaxis: {
          title: {
            text: this.$t('pages.statistics.developer-stat.developer-label'),
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val;
            },
          },
        },
      },
    };
  },
  created() {
    this.getStatistics();
    this.getTotalDeveloper();
    this.getApprovedDeveloper();
    this.getUnapprovedDeveloper();
  },
  methods: {
    getStatistics() {
      this.isChartLoading = true;
      this.$appAxios.post(this.$endpoints.developer_chart)
        .then(response => {
          if (response.data.status === true) {
            const values = Object.values(response.data.data.data);
            this.series[0].data = values;
          }
          this.isChartLoading = false;
        })
        .catch(e => {
        });
    },
    getTotalDeveloper() {
      this.isCard_1_Loading = true;
      this.$appAxios.post(this.$endpoints.developer_total, {date : this.date_info})
        .then(response => {
          if (response.data.status === true) {
            this.totalDeveloper = response.data.data;
          }
          this.isCard_1_Loading = false;
        })
        .catch(e => {
        });
    },
    getApprovedDeveloper() {
      this.isCard_2_Loading = true;
      this.$appAxios.post(this.$endpoints.developer_approved, {date : this.date_info})
        .then(response => {
          if (response.data.status === true) {
            this.approvedDeveloper = response.data.data;
          }
          this.isCard_2_Loading = false;
        })
        .catch(e => {
        });
    },
    getUnapprovedDeveloper() {
      this.isCard_3_Loading = true;
      this.$appAxios.post(this.$endpoints.developer_unapproeved, {date : this.date_info})
        .then(response => {
          if (response.data.status === true) {
            this.unapprovedDeveloper = response.data.data;
          } 
          this.isCard_3_Loading = false;
        })
        .catch(e => {
        });
    },
  },
  computed: {
    ...mapGetters({
      date_info: 'statistics/get_date_info',
    }),
  },
  watch: {
    date_info(newValue, oldValue) {
      this.getTotalDeveloper();
      this.getApprovedDeveloper();
      this.getUnapprovedDeveloper();
    },
  },
};
</script>
